import React, { useEffect, useState } from "react";
import { isEmpty } from "helper/Functions";
import { cn } from "helper/Utils";
import { useSearchParams } from "react-router-dom";
import { SkeletonLoader } from "components/ui/loaders/SkeletonLoader";
import { useTranslation } from "react-i18next";

export const ProviderListSearch = ({
  data,
  selectedProviders,
  toggleProviderSelection,
  searchProviders,
  setSearchProviders,
  isProvidersVisible,
  isMobile,
  isLoading,
}) => {
  const { t } = useTranslation();
  const [isViewGrid, setIsViewGrid] = useState(true);

  return (
    <div
      className={cn(
        "bg-body transition-transform duration-300 ease-in-out lg:h-auto w-full",
        isProvidersVisible ? "translate-x-0" : "-translate-x-full -ml-3 hidden"
      )}
    >
      <style jsx="true">
        {`
          .provider:hover img,
          .provider.active img {
            filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(345deg) brightness(100%) contrast(104%);
          }
        `}
      </style>
      {/* MOBILE */}
      {isMobile && (
        <div className={cn("sm:hidden block mt-1 mb-3")}>
          <input
            value={searchProviders}
            onChange={(e) => setSearchProviders(e.target.value)}
            type="text"
            className="w-full h-11 relative bg-[rgb(38,48,69,1)] text-md text-white pl-3 rounded !border-0"
            placeholder={t("Provider Search")}
          />
          <div className="searchInputIcon">
            <i className="bc-i-search absolute bottom-1 right-3 text-white top-[14px]"></i>
          </div>
        </div>
      )}
      {/* MOBILE */}
      <div className="flex justify-between items-center leading-none md:max-h-[calc(100vh-180px)]  bg-body z-50 py-1">
        <p className="text-white opacity-70 flex items-center gap-2">
          {/* {!isEmpty(selectedProviders) ? selectedProviders.length : null} */}
          {t("Providers")}{" "}
          {/* {!isEmpty(selectedProviders) ? (
            <i className="bc-i-clear text-white/60 hover:text-white/100 cursor-pointer" onClick={() => toggleProviderSelection([], "clear")} />
          ) : null} */}
        </p>
        <div className="flex gap-3 pl-3 border-l border-white/10 text-white/90 ">
          <span onClick={() => setIsViewGrid(false)}>
            <i className={cn("bc-i-view-list text-[22px] text-white opacity-50", !isViewGrid ? "opacity-100" : "")} />
          </span>
          <span onClick={() => setIsViewGrid(true)}>
            <i className={cn("bc-i-view-module text-[22px] text-white opacity-50", isViewGrid ? "opacity-100" : "")} />
          </span>
        </div>
      </div>
      <div
        className={cn(
          "grid gap-1 mt-2 sm:max-h-[calc(100vh-210px)] max-h-[calc(100vh-320px)] overflow-y-auto hide-scrollbar sm:pb-0 pb-10",
          isViewGrid ? "sm:grid-cols-3 grid-cols-4" : "grid-cols-1"
        )}
      >
        {isLoading
          ? Array.from({ length: 27 }).map((_, index) => <SkeletonLoader className="h-[80px]" key={index} />)
          : data &&
            data.map((item, index) => (
              <button
                key={item._id}
                onClick={() => toggleProviderSelection(item)}
                className={cn(
                  "provider bg-opacity-60 rounded flex items-center p-2 text-white text-center text-[12px] bg-[#263045]",
                  "sm:hover:bg-[rgb(255,255,255,.9)] sm:hover:text-body icon-black",
                  isViewGrid ? "h-[80px] justify-center" : "w-full h-auto justify-start",
                  // selectedProviders?.includes(item) ? "bg-[rgb(255,255,255,.9)] text-body" : ""
                  item.provider_name === selectedProviders ? "bg-[rgb(255,255,255,.9)] text-body active" : ""
                )}
              >
                {isViewGrid ? <img src={item.providerLogos.image_white} alt="providers logo" /> : item.provider_name}
              </button>
            ))}
      </div>
    </div>
  );
};
